import React, { Component } from 'react';
import FX from './functions/functions';
import { Scrollbars } from 'react-custom-scrollbars';
import CountryList from './functions/CountryList';
import Modal from './Modal';
import './css/AddressEditor.css';

class AddressEditor extends Component {
  constructor(props) {
    super(props);
    if(this.props.root.state.detail[this.props.varTgt]){
        this.state = this.props.root.state.detail[this.props.varTgt];
    }
    else {
        this.state = {country_code:'GB'};
    }
    this.state.list = [];
  }
  mandatory = [['title','forename','surname'],'line_1','city','country_code'];

  lookup = () => {
    this.setState({lookup: !this.state.lookup});
  }
  update = (field,evt,callback) => {
     if(typeof evt === 'function'){
        var tn = callback;
        callback = evt;
        evt = tn;
     }
     var state = {};
     state[field] = evt.target.value;
     if(field === 'country_code'){
       console.log(CountryList.getCountryByCode(evt.target.value));

        state['country'] = CountryList.getCountryByCode(evt.target.value);
        state[field] = state[field].toUpperCase();
     }
     else if(field == 'postcode'){
      state[field] = state[field].toUpperCase();
     }
     else if(field == 'email'){
      state[field] = state[field].toLowerCase();
     }
     console.log(state);
     if(typeof callback === 'function'){
       this.setState(state,callback);
     }
     else {
       this.setState(state);
     }
	}
  loadAddresses = () => {
    FX.load(this.props.root,'shopper_address/lookup?customer_id='+ this.props.root.state.customer_id + '&lookup=' + document.getElementById('lookup_text').value  , (res, i) => {
          console.log(res)
          this.setState({lookupList:res});
    });


      /*
       var xhr = new XMLHttpRequest();
       xhr.onreadystatechange = () => {
        var DONE = 4; // readyState 4 means the request is done.
        var OK = 200; // status 200 is a successful return.
        if (xhr.readyState === DONE) {
          //this.props.root.setState({waiting: false});
          document.getElementById('lookup_text').classList.remove('wait');
          if (parseInt(xhr.status, 10) === OK) {
              var retx;
              try{
                retx = JSON.parse(xhr.responseText);
                this.setState({list : retx});
                console.log(retx);
              }
              catch (e){
                console.log(e);
                console.log(xhr.responseText);
              }
	          }
          }
          else if (xhr.status) {
          }
      };
      if(localStorage.token){
        xhr.open('POST', FX.apiHost + '/shoppers');
        xhr.setRequestHeader("X-Token-Sec", localStorage.token);
        //xhr.send(JSON.stringify({customer_id:this.props.root.state.customer_id,surname:this.state.surname}));
        //this.props.root.setState({waiting: true, blockChange: false});
       // document.getElementById('lookup').classList.add('wait');
      }
      */
  }
  considerAddresses = () => {
     window.clearTimeout(window.address);
     window.address = window.setTimeout(this.loadAddresses, 1000);
  }
  applyLoaded = (name) => {
    this.setState(name)
  }
	close = (commit) => {
	  if(!commit){
	    this.props.hideAddress(false);
	  }
	  else {
	    var invalid = '';
	    var subValid = true;
	    if(
	      FX.validateAddress(this.state)
	    ){

        var out = this.state;
        delete this.state.list;
        delete this.state.lookupList;
	      console.log(out);
	      out.invalid = false;
	      this.props.hideAddress(out, this.props.varTgt);
	      this.props.root.setState({blockChange: true});
	    }
	    else {
	      alert('Please make sure that all of the mandatory fields are completed');
	    }
	  }
	}
	setShopper = (shopper) => {
	  console.log(shopper);
	  shopper = Object.assign(shopper.shopper_address, {id:-1});
	  console.log(shopper);
	  this.setState(shopper);
	}
  render() {
    var countriesOptions = CountryList.countries.map((nat, i)=>{
      return <option key={i} value={nat.country_code}>{nat.country}</option>
    })
    /*
     var nameList = this.state.list.map((name, i)=>{
      return (<div className="ShopperAddress" key={i} onClick={this.applyLoaded.bind(this, name)}>
          <div className="name">{((name.title ? name.title : '') + ' ' + name.forename + ' ' + name.surname).trim()}</div>
        <div className="postcode">{(name.line_1 + ' ' + name.postcode)}</div>
      </div>);
    })
    <div id="lookup" className="lookup">{nameList}</div>


              <button onClick={this.close.bind(null, false)}>Cancel</button>
              <button onClick={this.close.bind(null, true)}>Apply</button>

    */
    var lookup;
    var classTag = '';
    var list;
    if(this.state.lookupList){
      list  = this.state.lookupList.map(shopper => {
        return (<div className="option"  onClick={this.setShopper.bind(this, shopper)}>{shopper.shopper_address.surname}</div>)
      })
    }
    if(this.state.lookup){
      lookup = (
            <div className="leftBar lookup">
              <input id="lookup_text" onChange={this.loadAddresses} />
              <div className="lookup_list">
                <Scrollbars  style={{ position: 'absolute', top:30, left: 0, bottom: 0, padding: '20px', width: 300, height: 'auto'}}>
                  {list}
                </Scrollbars>
              </div>
            </div>
            )
      classTag = 'lookup'
    }

    return (
        <Modal fs={true} sideBar={lookup} buttons={[{text:'Lookup',left:true, action:this.lookup},{text:'Cancel',action:this.close.bind(null, false)},{text:'Save',action:this.close.bind(null, true)}]} title={FX.ucfirst(this.props.title) + " Address"} close={this.close.bind(null, false)}  >
          <div className={"AddressEditor " + classTag}>
          <div className="island">
            <div className="form">
              <div className="idents-personal">
                <div><label>Name<span className="mandatory">*</span>:</label><div className="namePut"><input className="name_title" value={this.state.title} placeholder="Title" onChange={this.update.bind(this,'title')} /><input placeholder="Forename" className="forename" value={this.state.forename} onChange={this.update.bind(this,'forename')} /><input className="surname" placeholder="Surname" value={this.state.surname} onChange={this.update.bind(this,'surname')} /></div></div>
              </div>
              <div className="idents-company">
                <div><label>Company<span className="mandatory">*</span>:</label><input value={this.state.company} onChange={this.update.bind(this,'company')} /></div>
              </div>
              <div className="idents-location">
                <div><label>Line 1<span className="mandatory">*</span>:</label><input value={this.state.line_1} onChange={this.update.bind(this,'line_1')} /></div>
                <div><label>Line 2:</label><input value={this.state.line_2} onChange={this.update.bind(this,'line_2')} /></div>
                <div><label>Line 3:</label><input value={this.state.line_3} onChange={this.update.bind(this,'line_3')} /></div>
              </div>
              <div className="idents-location">
                <div><label>City<span className="mandatory">*</span>:</label><input value={this.state.city} onChange={this.update.bind(this,'city')} /></div>
                <div><label>County:</label><input value={this.state.county} onChange={this.update.bind(this,'county')} /></div>
                <div><label>Country<span className="mandatory">*</span>:</label>
                  <select className="country_select" value={this.state.country_code} onChange={this.update.bind(this,'country_code')}>
                    {countriesOptions}
                  </select>
                </div>
                <div><label>Postcode<span className="mandatory">*</span>:</label><input value={this.state.postcode} onChange={this.update.bind(this,'postcode')} /></div>
              </div>
              <div className="idents-contact">
                <div><label>Email:</label><input value={this.state.email} onChange={this.update.bind(this,'email')} /></div>
                <div><label>Phone:</label><input value={this.state.phone_number} onChange={this.update.bind(this,'phone_number')} /></div>
              </div>
            </div>
      </div></div>
        </Modal>
    );
  }
}

export default AddressEditor;



// WEBPACK FOOTER //
// ./src/AddressEditor.js